import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { withTranslation } from "react-i18next";

const UpdateList = ({ onClick, loading, t }) => {
  return (
    <>
      <li
        className={`list-inline-item  d-none d-sm-inline-block ${
          !loading ? "showbtn" : ""
        }`}
      >
        <div
          className="btn nav-btn nav-btn-light-sec"
          onClick={onClick}
          id="updateEngagement"
        >
          <i
            className={`bx bx-refresh header-button-refresh ${
              loading ? "loading-spinning" : ""
            }`}
          ></i>
        </div>
      </li>
      <UncontrolledTooltip
        placement="bottom"
        target="updateEngagement"
        className="uncontrolledTooltip"
      >
        {t("Update engagement history")}
      </UncontrolledTooltip>
    </>
  );
};
export default withTranslation()(UpdateList);
